import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Box } from 'grid-styled'

import {
  fetchPlanData,
  fetchPaymentInfo,
  fetchTermsAndConditions,
  fetchDashboardResume,
  fetchBankList,
  checkEditAuthorizationPayment,
  fetchPaymentType,
  fetchDueDates,
  fetchGetUser,
  fetchGetBusinessUser
} from 'alelo-logic/actions'
import _ from 'lodash'
import PaymentMethods from '../../modules/PaymentMethods'

import Hide from '../../../styles/utilities/Hide'
import Content from '../../../styles/objects/Content'
import IconTextCarousel from '../../modules/IconTextCarousel'
import PlanResume from '../../modules/PlanResume'
// import CallBuyIdentifier from '../../modules/CallBuyIdentifier'
import CallDownloadTerms from '../../modules/CallDownloadTerms'

import { setLoading } from '../../modules/PageLoader/actions'
import { Separator, Container, FinancialInformation } from './styles'

import { dados } from './data.json'

import { gqlQuery } from '../../../alelo-logic/services/common/apolloClient'
import { gqlTotalIdentificadores } from '../../../alelo-logic/services/queries/vehicles'

class PlanData extends Component {
  state = {
    qtdTag: 0
  }

  async componentWillMount() {
    this.props.setLoading(true)
    const plan = this.props.accountPlans.plans.find(this.applyFilter)
    if ((this.props.account || {}).pc) {
      const qtdTag = await this.props.getTotalTags(this.props.match.params.id)
      this.setState({ qtdTag: qtdTag || 0 })
    } else {
      await this.props.fetchBankList()
      await this.props.getUser(this.props.account.accountType)
      await this.props.getPaymentInfo(plan.accountId)

      this.checkAuthorizations(plan.accountId)

      await this.props.fetchPaymentType()
      await this.props.fetchDueDates()
    }
    await this.props.fetchPlanData(plan)
    await this.props.downloadTermsAndConditions()
  }

  checkAuthorizations = async accountId => {
    const { plandata, checkEditAuthorizationPayment } = this.props
    if (_.isEmpty(plandata.authorizations)) {
      await checkEditAuthorizationPayment('FORMA', accountId)
      await checkEditAuthorizationPayment('DATA', accountId)
    } else {
      if (plandata.authorizations.FORMA && !plandata.authorizations.FORMA.error) {
        await checkEditAuthorizationPayment('FORMA', accountId)
      }
      if (plandata.authorizations.DATA && !plandata.authorizations.DATA.error) {
        await checkEditAuthorizationPayment('DATA', accountId)
      }
    }
  }

  shouldComponentUpdate(nextProps) {
    const hasPlanChange =
      this.props.accountPlans.activePlanId !== nextProps.accountPlans.activePlanId

    if (hasPlanChange) {
      this.props.fetchResume(this.props.match.params.id)
    }

    return true
  }

  applyFilter = checkPlan =>
    checkPlan.id.toString() === this.props.accountPlans.activePlanId.toString()

  render() {
    const { qtdTag } = this.state
    const { accountPlans, plandata, creditPaymentInfo, account } = this.props
    const currentPlan = accountPlans.plans[0] ? accountPlans.plans.find(this.applyFilter) : ''

    return (
      <Content>
        <Container>
          <Box width={[1, 3 / 12]}>
            <PlanResume showSummary qtdTag={qtdTag} />
            <Hide at="small">
              <CallDownloadTerms />
            </Hide>
          </Box>
          <FinancialInformation>
            {currentPlan &&
              !(account || {}).pc && (
                <PaymentMethods
                  currentPlan={currentPlan}
                  plandata={plandata}
                  creditPaymentInfo={creditPaymentInfo}
                  accountType={account.accountType}
                />
              )}
            <Separator />
            <IconTextCarousel data={dados} />
            {/* <CallBuyIdentifier smallSize /> */}
            <Hide at="large">
              <CallDownloadTerms />
            </Hide>
          </FinancialInformation>
        </Container>
      </Content>
    )
  }
}

const mapStateToProps = ({ reducer }) => ({
  account: reducer.account,
  resume: reducer.dashboardResume,
  accountPlans: reducer.accountPlans,
  plandata: reducer.planData,
  creditPaymentInfo: reducer.recharge.paymentInfo
})

const mapDispatchToProps = dispatch => ({
  getUser: userType => {
    if (userType === 'pf') {
      dispatch(fetchGetUser())
    } else {
      dispatch(fetchGetBusinessUser())
    }
  },
  getPaymentInfo: accountPlanId => dispatch(fetchPaymentInfo(accountPlanId)),
  fetchResume: (token, planId) => dispatch(fetchDashboardResume(token, planId)),
  checkEditAuthorizationPayment: (type, accountPlanId) =>
    dispatch(checkEditAuthorizationPayment(type, accountPlanId)),
  fetchPlanData: plano => dispatch(fetchPlanData(plano)).then(() => dispatch(setLoading(false))),
  fetchPaymentType: () => dispatch(fetchPaymentType()),
  downloadTermsAndConditions: () => dispatch(fetchTermsAndConditions()),
  fetchDueDates: () => dispatch(fetchDueDates()),
  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  },
  fetchBankList: () => dispatch(fetchBankList()),
  getTotalTags: async idConta => {
    const { data: { identificadoresPJV2: { paginacao: { total } } } } = await gqlQuery(
      gqlTotalIdentificadores,
      { idConta }
    )
    return total
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(PlanData)



// WEBPACK FOOTER //
// ./src/app/pages/PlanData/index.js